export enum Country {
  US = 'US',
  AU = 'AU',
  NZ = 'NZ',
}
